/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { type ErrorInfo } from "react";
import { addReactError } from "@datadog/browser-rum-react";

import "./style.less";
import { Button } from "antd";
import errorImage from "../../assets/images/error.png";
import i18n from "../../i18n";
import { formatTranslation } from "../utils/translationUtils";

class ErrorBoundary extends React.Component<
  { children: any },
  { hasError: boolean; error: any; info: any }
> {
  public static getDerivedStateFromError() {
    return { hasError: true };
  }

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  public componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info);
    addReactError(error, info);
    this.setState({ hasError: true, error, info });
  }

  private readonly handleRetry = () => {
    this.setState({ hasError: false, error: null, info: null });
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <img
            src={errorImage}
            alt={formatTranslation(i18n.t("errorBoundary.imageAlt"))}
            style={{ width: 500 }}
          />
          <h1 className="error-heading">
            {formatTranslation(i18n.t("errorBoundary.title"))}
          </h1>
          <p className="error-description">
            {formatTranslation(i18n.t("errorBoundary.description"))}
          </p>
          <Button
            className="error-retry-btn"
            size="large"
            onClick={this.handleRetry}
          >
            {formatTranslation(i18n.t("autozones.tryAgain"))}
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}

export { ErrorBoundary };
